jQuery(document).ready(function ($) {
    "use strict";

    // Get the hidden select and input fields from the Pickup Plus plugin HTML
    const clickAndCollectSelect = $('input[data-pickup-object-id], select[data-pickup-object-id]');

    // Find the button on the page with the default centre ID
    const clickAndCollectButton = $('[data-default-centre]');
    // Find any checked delivery option buttons
    const selectedClickAndCollect = $('.delivery-buttons__button--checked');

    // If we have a default centre on the page, proceed
    if (clickAndCollectButton.length !== 0) {

        // If we don't have the click and collect plugin fields on the page, return
        if (clickAndCollectSelect.length === 0) {
            return;
        }
        
        // If a delivery option is selected on page load
        if (selectedClickAndCollect.length !== 0) {
            // Get the centre assigned to the customer by default
            const centre = selectedClickAndCollect.data('default-centre');

            // If we have a centre, set the hidden input values behind the scenes
            if (centre) {
                clickAndCollectSelect.val(centre); 
              
            }
        }

        // If the customer has clicked on a delivery option button
        clickAndCollectButton.on('click', function () {
            // If we have default centre ID
            const centre = $(this).data('default-centre');
        
            if (centre) {
                // Set the hidden fields in the background
                clickAndCollectSelect.val(centre); 
              
            }
        });
    }

});